export const LogSvgNotFound = {
  mounted() {
    const { svgPath = ':: path ::', brandName = ':: brand ::' } = this.el.dataset;
    // eslint-disable-next-line no-console
    console.log(`SVG: ${svgPath} for Brand: ${brandName} was not found.`);
  }
};
